var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVerticalObject = function SvgVerticalObject(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 14.5H4.00031C2.89574 14.5 2.00031 15.3954 2.00031 16.5V20.4999C2.00031 21.6045 2.89574 22.4999 4.00031 22.4999H20C21.1045 22.4999 22 21.6045 22 20.4999V16.5C22 15.3954 21.1045 14.5 20 14.5Z",
    stroke: "#495057",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 2.5H4C2.89543 2.5 2 3.39543 2 4.5V5.16667",
    stroke: "#495057",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 2.5H20C21.1046 2.5 22 3.39543 22 4.5V5.16667",
    stroke: "#495057",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 10.5H4C2.89543 10.5 2 9.60457 2 8.5V7.83333",
    stroke: "#495057",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3333 10.5H20C21.1046 10.5 22 9.60457 22 8.5V7.83333",
    stroke: "#495057",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33331 2.5H10.6666",
    stroke: "#495057",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2.5H16.6666",
    stroke: "#495057",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33331 10.5H10.6666",
    stroke: "#495057",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 10.5H16.6666",
    stroke: "#495057",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVerticalObject);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjUiIHZpZXdCb3g9IjAgMCAyNCAyNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIwIDE0LjVINC4wMDAzMUMyLjg5NTc0IDE0LjUgMi4wMDAzMSAxNS4zOTU0IDIuMDAwMzEgMTYuNVYyMC40OTk5QzIuMDAwMzEgMjEuNjA0NSAyLjg5NTc0IDIyLjQ5OTkgNC4wMDAzMSAyMi40OTk5SDIwQzIxLjEwNDUgMjIuNDk5OSAyMiAyMS42MDQ1IDIyIDIwLjQ5OTlWMTYuNUMyMiAxNS4zOTU0IDIxLjEwNDUgMTQuNSAyMCAxNC41WiIgc3Ryb2tlPSIjNDk1MDU3IiBzdHJva2Utd2lkdGg9IjEuMzMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNNC42NjY2NyAyLjVINEMyLjg5NTQzIDIuNSAyIDMuMzk1NDMgMiA0LjVWNS4xNjY2NyIgc3Ryb2tlPSIjNDk1MDU3IiBzdHJva2Utd2lkdGg9IjEuMzMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTkuMzMzMyAyLjVIMjBDMjEuMTA0NiAyLjUgMjIgMy4zOTU0MyAyMiA0LjVWNS4xNjY2NyIgc3Ryb2tlPSIjNDk1MDU3IiBzdHJva2Utd2lkdGg9IjEuMzMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNNC42NjY2NyAxMC41SDRDMi44OTU0MyAxMC41IDIgOS42MDQ1NyAyIDguNVY3LjgzMzMzIiBzdHJva2U9IiM0OTUwNTciIHN0cm9rZS13aWR0aD0iMS4zMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0xOS4zMzMzIDEwLjVIMjBDMjEuMTA0NiAxMC41IDIyIDkuNjA0NTcgMjIgOC41VjcuODMzMzMiIHN0cm9rZT0iIzQ5NTA1NyIgc3Ryb2tlLXdpZHRoPSIxLjMzIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTcuMzMzMzEgMi41SDEwLjY2NjYiIHN0cm9rZT0iIzQ5NTA1NyIgc3Ryb2tlLXdpZHRoPSIxLjMzIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTEzLjMzMzMgMi41SDE2LjY2NjYiIHN0cm9rZT0iIzQ5NTA1NyIgc3Ryb2tlLXdpZHRoPSIxLjMzIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPHBhdGggZD0iTTcuMzMzMzEgMTAuNUgxMC42NjY2IiBzdHJva2U9IiM0OTUwNTciIHN0cm9rZS13aWR0aD0iMS4zMyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMy4zMzMzIDEwLjVIMTYuNjY2NiIgc3Ryb2tlPSIjNDk1MDU3IiBzdHJva2Utd2lkdGg9IjEuMzMiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L3N2Zz4K";